import { Injectable, signal } from '@angular/core'

export interface AppNotification {
  title: string
  text: string
  type: 'error' | 'success' | 'warning' | 'info'
  timeout: number
}

@Injectable({ providedIn: 'root' })
export class NotificationService {
  readonly notification = signal<AppNotification | null>(null)

  show(n: AppNotification): void {
    this.notification.set(n)
    setTimeout(() => this.notification.set(null), n.timeout)
  }

  error(title: string, text: string, timeout = 7000): void {
    this.show({ title, text, type: 'error', timeout })
  }

  success(title: string, text: string, timeout = 4000): void {
    this.show({ title, text, type: 'success', timeout })
  }
}
